const trainers = [
  {
    id: 'vasanthi-se',
    name: 'Vasanthi S.E',
    title: 'Senior Director – Pharmacovigilance & Medical Safety',
    experience: 'Nearly 24 years of rich experience',
    bio: 'With nearly 24 years of rich experience in Medical Safety Projects, Delivery Management, client engagement, People Management, learning & development. Currently serving as Senior Director – Pharmacovigilance & Medical Safety at Thrana, Vasanthi spearheads end-to-end safety operations strategy, delivery oversight, partner engagement, and capability development to support Thrana\'s growing portfolio of innovative safety technology and service offerings.',
    expertise: [
      'Medical Safety Projects',
      'Delivery Management',
      'Client Engagement',
      'People Management',
      'Learning & Development',
      'End-to-end Safety Operations Strategy',
      'Partner Engagement',
      'Capability Development',
    ],
    certifications: [
      'Senior Director – Pharmacovigilance & Medical Safety',
      '24 years of experience in Medical Safety',
    ],
    courses: [1, 2, 3, 4, 5, 6, 7], // All courses
    achievements: [
      'Nearly 24 years of rich experience in Medical Safety Projects',
      'Expert in Delivery Management and Client Engagement',
      'Specialized in People Management and Learning & Development',
    ],
    photo:
      'https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=600&q=80',
    email: 'vasanthi.se@thranatech.com',
    linkedin: 'https://www.linkedin.com/in/vasanthi-shimoga-eswarappa-a144a7237/',
  },
  {
    id: 'sunil-pandita',
    name: 'Sunil Pandita',
    title: 'Chief Strategic & Scientific Officer',
    experience: 'Nearly 20 years of experience in clinical research',
    bio: 'Sunil Pandita is a Quality Assurance and GCP auditor with nearly 20 years of experience in clinical research. He has led audits across Clinical operations, Data Management, Pharmacovigilance, BIOS, and Vendor process. With deep expertise in Global regulatory framework and compliance.',
    expertise: [
      'Quality Assurance',
      'GCP Auditing',
      'Clinical Operations',
      'Data Management Audits',
      'Pharmacovigilance Audits',
      'BIOS Audits',
      'Vendor Process Audits',
      'Global Regulatory Framework',
      'Compliance',
    ],
    certifications: [
      'Quality Assurance and GCP Auditor',
      '20 years of experience in clinical research',
    ],
    courses: [1, 2, 3, 4, 5, 6, 7], // All courses
    achievements: [
      'Nearly 20 years of experience in clinical research',
      'Led audits across Clinical operations, Data Management, Pharmacovigilance, BIOS, and Vendor process',
      'Deep expertise in Global regulatory framework and compliance',
    ],
    photo:
      'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=600&q=80',
    email: 'sunil.pandita@thranatech.com',
    linkedin: 'https://www.linkedin.com/in/sunil-pandita-thrana',
  },
  {
    id: 'dr-sarah-johnson',
    name: 'Dr. Sarah Johnson',
    title: 'Principal Pharmacovigilance Trainer',
    experience: '18+ years in drug safety & regulatory affairs',
    bio: 'Former Head of Pharmacovigilance at a top 10 global pharma company with hands-on experience across case processing, signal management, and global submissions. Dr. Johnson has trained over 1,500 safety professionals worldwide and serves on multiple regulatory advisory boards.',
    expertise: [
      'Global Pharmacovigilance Regulations (FDA, EMA, MHRA)',
      'Signal Detection & Benefit-Risk Assessment',
      'Safety Database Implementation',
      'Inspection Readiness & Quality Systems',
    ],
    certifications: [
      'MD, Clinical Pharmacology',
      'Fellow, Drug Safety Leadership Council',
      'Certified Pharmacovigilance Professional (CPP)',
    ],
    courses: [], // No longer assigned to courses
    achievements: [
      'Led more than 50 successful regulatory inspections',
      'Implemented end-to-end PV systems for 25+ global launches',
      'Published 30+ peer-reviewed safety research papers',
    ],
    photo:
      'https://images.unsplash.com/photo-1524504388940-b1c1722653e1?auto=format&fit=crop&w=600&q=80',
    email: 'sarah.johnson@thranatech.com',
    linkedin: 'https://www.linkedin.com/in/sarah-johnson-thrana',
  },
];

export default trainers;

